import { breakpoints, colors } from 'definitions';
import styled from 'styled-components';
import { HeaderSectionEntriesContainer } from 'App/styles';
import { addOpacityToColor } from 'helpers';

export const ContainerAnimated = styled.div`
    width: 95%;
    max-width: 124.5rem;

    ${breakpoints.tablet}{
        width: 80%;
    }
`;

// Explica para qué sirve la pantalla: las cuatro del menú Jurado comparten
// este componente y, sin el texto, sólo se distinguían por el título.
export const PageDescription = styled.p`
    width: 95%;
    max-width: 124.5rem;
    margin: 3rem 0 0 0;
    font-family: Lato;
    font-size: 16px;
    line-height: 24px;
    color: ${colors.fonts.darkGray};

    ${breakpoints.tablet}{
        width: 80%;
    }
`;

// Aviso de que el paso está fuera de sus fechas y la pantalla es de sólo
// lectura. Va con el azul de las pantallas del jurado (ver `EntryWorkflow`).
export const StageNotice = styled.p`
    width: 95%;
    max-width: 124.5rem;
    box-sizing: border-box;
    margin: 2rem 0 0 0;
    padding: 1.2rem 1.6rem;
    border-left: 4px solid ${colors.background.gray};
    background-color: ${addOpacityToColor(colors.background.gray, 0.08)};
    font-family: Lato;
    font-size: 16px;
    line-height: 24px;
    color: ${colors.fonts.darkGray};

    ${breakpoints.tablet}{
        width: 80%;
    }
`;

// El que se monta sobre el hero es el gráfico del proceso (`EntryWorkflow`):
// el filtro va debajo, sin el margen negativo de `OverHeroContainer`.
export const Filter = styled(HeaderSectionEntriesContainer)`
    margin: 2.4rem 0 0 0;
`;

// Filtro con buscador (Preselección): buscador y premio lado a lado y el botón al
// final. Es una grilla porque la base reparte los campos con `flex-basis`
// al 100% y, con dos campos, los apretaba.
export const EntriesFilter = styled(Filter)`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr)) auto;
    column-gap: 2rem;
    row-gap: 1.5rem;
    align-items: end;
    height: auto;

    button {
        margin-top: 0;
    }

    ${breakpoints.laptop}{
        grid-template-columns: minmax(0, 1fr);
    }
`;
